export default {
  title: '运输计划单',
  pageTitles: {
    detail: '运输计划详情',
    edit: '编辑运输计划单'
  },
  list: {
    filterTitle: '运输计划单筛选',
    exportTitle: '运输计划单列表'
  },
  tabs: {
    basic: '基础信息',
    tracking: '运踪',
    fee: '费用'
  },
  actions: {
    detail: '详情',
    edit: '编辑',
    operationHistory: '操作历史',
    cancel: '取消',
    save: '保存',
    print: '打印',
    split: '拆单',
    generateConsignment: '生成运输委托单',
    confirmGenerate: '确认生成',
    addPlan: '+ 新增计划单',
    removePlan: '- 删除计划单',
    confirmSplit: '确认拆分'
  },
  common: {
    yes: '是',
    no: '否',
    noData: '暂无数据',
    noProductData: '暂无商品数据',
    noTrackingRecords: '暂无运踪记录',
    noFeeData: '暂无费用数据',
    noOperationRecords: '暂无操作记录',
    noConsignmentDetail: '暂无委托单详情数据'
  },
  sections: {
    orderBase: '订单基础信息',
    logistics: '物流信息',
    packageWeightVolume: '件重尺',
    businessTags: '业务自定义标签',
    productInfo: '商品信息'
  },
  fields: {
    planNo: '运输计划单号',
    planNoShort: '计划单号',
    orderStatus: '主状态',
    orderStatusDetail: '订单状态',
    createStatus: '下级委托单状态',
    transportSegment: '运输段落',
    segmentOrigin: '本段起运地',
    segmentDestination: '本段目的地',
    mainlineOriginCountry: '干线起运国',
    mainlineDestCountry: '干线目的国',
    portOfLoading: '起运港',
    portOfDischarge: '目的港',
    fhNo: '关联发货申请单号',
    businessCategory: '业务类',
    fhCateg: '业务类编码',
    fhCategName: '业务类名称',
    regionCodePath: '区域编码',
    regionPath: '区域',
    costCenter: '成本中心编码',
    costCenterName: '成本中心',
    salesType: '销售模式编码',
    salesTypeName: '销售模式名称',
    bizDept: '业务部门编码',
    departmentName: '业务部门',
    fhNoShort: '关联FH单',
    fhNoDetail: '关联FH单号',
    wtNo: '关联运输委托单号',
    wtNoDetail: '运输委托单号',
    goodsType: '货品信息',
    cusShortName: '客户简称',
    cusNo: '客户编码',
    createdAt: '创建时间',
    creator: '创建人',
    updatedAt: '更新时间',
    updater: '更新人',
    omsRemark: '订单备注',
    logisticsOperator: '物流操作员',
    tradeChain: '贸易链路',
    customsTradeTerm: '贸易条款（报关）',
    clearanceTradeTerm: '贸易条款（清关）',
    transportTerms: '运输条款',
    crossBorder: '是否跨境',
    logisticsDirection: '物流流向',
    customerConsignment: '是否客户指定',
    segmentTransportMode: '本段运输业务类型',
    carrier: '承运商',
    consignmentNo: '委托单号',
    waybillNo: '运单号/提单号',
    destinationWh: '目的仓库',
    destinationWhCode: '目的仓库编码',
    expectShipDate: '本段期望发货时间',
    expectDepartureTime: '本段期望出发时间（ETD）',
    actShipDate: '本段实际发货时间',
    actualShipTime: '实际发货时间',
    expectArrivalDate: '本段期望到货时间',
    expectArrivalTime: '本段期望到达时间（ETA）',
    actArrivalDate: '本段实际到货时间',
    actualArrivalTime: '实际到达时间',
    hsCode: 'HS编码',
    originCountry: '原产国',
    tmsRemark: '运输备注',
    bizTags: '业务标签',
    currentTrackingNode: '当前运综节点',
    actions: '操作',
    warehouse: '发货仓库'
  },
  placeholders: {
    planNo: '请输入运输计划单号，多个用逗号/空格分隔',
    fhNo: '请输入关联发货申请单号，多个用逗号/空格分隔',
    transportSegment: '请选择运输段落',
    segmentTransportMode: '请选择运输业务类型',
    orderStatus: '请选择主状态',
    createStatus: '请选择下级委托单状态',
    segmentOrigin: '请选择本段起运地',
    segmentDestination: '请选择本段目的地',
    destinationWh: '请选择目的仓库',
    destinationWhCode: '请选择目的仓库编码',
    mainlineOriginCountry: '请选择干线起运国',
    mainlineDestCountry: '请选择干线目的国',
    portOfLoading: '请输入起运港代码',
    portOfDischarge: '请输入目的港代码',
    currentTrackingNode: '请输入当前运综节点',
    cusShortName: '请输入客户简称',
    cusNo: '请输入客户编码',
    createdAt: '请选择创建时间',
    creator: '请输入创建人',
    omsRemark: '请输入订单备注',
    logisticsOperator: '请输入物流操作员ID',
    updatedAt: '请选择更新时间',
    tradeChain: '请输入贸易链路',
    customsTradeTerm: '请选择贸易条款（报关）',
    clearanceTradeTerm: '请选择贸易条款（清关）',
    tradeTerm: '请选择贸易条款',
    transportTerms: '请选择运输条款',
    crossBorder: '请选择是否跨境',
    logisticsDirection: '请选择物流流向',
    customerConsignment: '请选择是否客户指定',
    goodsType: '请选择货品信息',
    wtNo: '请输入关联运输委托单号',
    expectShipDate: '请选择本段期望发货时间',
    actShipDate: '请选择本段实际发货时间',
    expectArrivalDate: '请选择本段期望到货时间',
    actArrivalDate: '请选择本段实际到货时间',
    hsCode: '请输入HS编码',
    originCountry: '请选择原产国',
    tmsRemark: '请输入运输备注',
    bizTags: '请输入业务标签',
    bizTagsSelect: '请输入或选择业务标签'
  },
  enums: {
    transportSegment: {
      prePort: '港前',
      main: '干线',
      final: '尾程',
      full: '全程'
    },
    orderStatus: {
      created: '已创建',
      reviewed: '已审核',
      operating: '正操作',
      completed: '已完成',
      frozen: '已冻结',
      cancelled: '已取消'
    },
    createStatus: {
      notCreated: '未创建',
      created: '已创建'
    },
    mergeStatus: {
      notMerged: '未合单',
      merged: '已合单'
    },
    transportMode: {
      fcl: '海运整箱',
      lcl: '海运拼箱',
      air: '空运',
      road: '陆运',
      rail: '铁路',
      express: '快递',
      other: '其他'
    },
    logisticsDirection: {
      forward: '正向',
      reverse: '逆向'
    },
    goodsType: {
      standard: '标准产品',
      marketing: '营销物料',
      rawMaterial: '原材料',
      gift: '赠品'
    }
  },
  weightVolume: {
    dataSource: '数据来源',
    totalQty: '总个数',
    totalVolume: '总体积',
    totalWeight: '总重量',
    chargeableWeight: '计费重',
    length: '长',
    width: '宽',
    height: '高',
    expected: '理论值',
    warehouse: '仓库数据',
    supplier: '货代数据'
  },
  productColumns: {
    index: '行号',
    skuCode: 'SKU/物料编码',
    productName: '产品名称',
    productModel: '产品型号',
    brand: '品牌',
    specialAttributes: '货品特殊属性',
    barCode: 'UPC条码',
    pcsQty: '件数',
    boxGauge: '外箱规格',
    stdBoxQty: '标箱数量',
    actualBoxQty: '实际箱数',
    packingMethod: '包装方式',
    hsCodeLine: '海关编码',
    cnDesc: '中文描述',
    enDesc: '英文描述',
    customsDecl: '海关申报',
    amountOrigin: '原金额',
    unitPriceOrigin: '原单价',
    unitPrice: '含税单价',
    unitPriceNet: '不含税单价',
    amtnNet: '未税金额',
    amtnFh: '含税金额',
    tax: '税额',
    taxRto: '税率',
    unitPriceQg: '清关不含税单价',
    amountNetQg: '清关不含税金额',
    amountTaxQg: '清关税额',
    amountAllQg: '清关含税金额',
    currencyQg: '清关货币',
    unitPriceBg: '报关不含税单价',
    amountNetBg: '报关不含税金额',
    amountTaxBg: '报关税额',
    amountAllBg: '报关含税金额',
    currencyBg: '报关货币',
    cusPoNo: '客户PO号',
    multiCurrency: '（多币种）'
  },
  productSummary: {
    totalQuantity: '总个数',
    productAmount: '商品金额',
    totalTax: '总税额',
    customsAmount: '报关货值',
    clearanceAmount: '清关货值'
  },
  split: {
    title: '拆分计划单',
    rule: '拆分规则',
    full: '整体拆分',
    partial: '部分拆分',
    sku: 'SKU',
    productName: '商品名称',
    order: '订单',
    currentPlan: '本计划单',
    newPlan: '新增计划单{index}',
    qty: '件数',
    boxQty: '箱数'
  },
  generateConsignment: {
    title: '生成运输委托单',
    selectedHint: '已选 {count} 张',
    groupName: '委托单{index}',
    rules: {
      title: '合单规则',
      full: '① 基础条件：运输段落、本段起运地和本段目的地一致；快递或客户指定供应商不可合单',
      segment: '② 地址校验：有港前校验发货详细地址，有尾程校验收货详细地址；纯干线不校验门点地址',
      express: '③ 计划地址缺失时使用同一 FH 发货申请单地址兜底，两处都缺失则独立生成委托单',
      single: '④ 地址仅比较国家至邮编等地址字段并忽略首尾空格；联系人不同仍合单，取 FH 单号最小计划的信息并提示'
    },
    summary: {
      selected: '已选计划',
      customerSpecified: '客户指定',
      express: '快递',
      willGenerate: '预计生成',
      unit: '张委托单'
    },
    table: {
      consignment: '委托单',
      remark: '说明'
    },
    selectableOnly: '仅主状态为已创建且下级委托单未创建的计划单可勾选',
    detailLoadFailed: '部分运输计划详情加载失败，件重尺汇总可能不完整',
    previewLoadFailed: '合单预览加载失败，当前暂按每张计划独立展示；实际生成仍以后端规则为准',
    reasons: {
      customerSpecified: '客户指定',
      express: '快递'
    }
  },
  drawer: {
    consignmentTitle: '运输委托单：{no}'
  },
  messages: {
    loadListFailed: '加载运输计划列表失败',
    idRequired: '运输计划单ID不能为空',
    loadDetailFailed: '加载运输计划详情失败',
    distributionShipmentNotFound: '未找到发货申请单【{no}】，无法打开详情',
    distributionShipmentOpenFailed: '打开发货申请单详情失败，请重试',
    transportConsignmentNotFound: '未找到运输委托单【{no}】，无法打开详情',
    transportConsignmentOpenFailed: '打开运输委托单详情失败，请重试',
    editCreatedOnly: '仅主状态为已创建的运输计划允许编辑',
    saveSuccess: '保存成功',
    saveFailed: '保存运输计划失败',
    printInfo: '打印运输计划单',
    splitSuccess: '拆单成功',
    selectPlanFirst: '请先勾选计划单',
    generateConsignmentTodo: '生成运输委托单逻辑待接入',
    generateConsignmentSuccess: '生成运输委托单成功：{nos}',
    generateConsignmentSuccessCopied: '生成运输委托单成功，委托单号已复制到剪贴板：{nos}',
    generateConsignmentCopyFailed: '委托单号自动复制失败，请手动复制',
    generateConsignmentFailed: '生成运输委托单失败',
    splitQtyExceeded: '{name} 件数超出订单数量（订单 {orderQty} 件，已填 {totalQty} 件），请修改后重试',
    splitBoxExceeded: '{name} 箱数超出订单数量（订单 {orderQty} 箱，已填 {totalQty} 箱），请修改后重试'
  }
}
